import { CaretRightIcon } from "@phosphor-icons/react/dist/csr/CaretRight";
import cn from "classnames";

import styles from "./block-header.module.scss";

interface BlockHeaderProps {
  name: string;
  completed: number;
  total: number;
  isExpanded: boolean;
  isCurrent: boolean;
  onToggle: () => void;
  "data-testid"?: string;
}

export function BlockHeader({
  name,
  completed,
  total,
  isExpanded,
  isCurrent,
  onToggle,
  "data-testid": testId,
}: BlockHeaderProps) {
  const progress = total > 0 ? completed / total : 0;

  return (
    <button
      type="button"
      className={cn(styles.header, isCurrent && styles.current)}
      onClick={onToggle}
      data-testid={testId}
      aria-expanded={isExpanded}
    >
      <span className={styles.name}>{name}</span>
      <div className={styles.progressBar}>
        <div className={styles.progressFill} style={{ width: `${progress * 100}%` }} />
      </div>
      <span className={styles.count}>
        {completed}/{total}
      </span>
      <span className={cn(styles.chevron, isExpanded && styles.expanded)}>
        <CaretRightIcon size={20} aria-hidden="true" />
      </span>
    </button>
  );
}
